import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { Radar } from "react-chartjs-2";
import { alpha } from "@mui/material/styles";
import { PROJECT_COLOR } from "../../../constants/colors";
import { useIsDesktop } from "../../shared/hooks/useIsDesktop";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";

/**
 * レーダーチャート用ラベルを自然に改行する
 */
const wrapLabelNatural = (label) => {
  const map = {
    コミュニケーション能力: ["コミュニケーション", "能力"],
    チームへの貢献度: ["チームへの", "貢献度"],
    学習意欲と成長: ["学習意欲と", "成長"],
    自律性と責任感: ["自律性と", "責任感"],
  };

  return map[label] || label;
};

/**
 * Chart.js はグローバル登録が必要なため、
 * レーダーチャートを使用するこのファイル内で一度だけ登録する
 */
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
);

/**
 * ヒューマンスキルのレーダーチャート（Chart.js）
 * - 表示専用
 */
const HumanSkillRadar = ({ humanSkills, maxScore }) => {
  const isDesktop = useIsDesktop();

  const chartData = useMemo(() => {
    return {
      labels: humanSkills.map((s) => wrapLabelNatural(s.label)),
      datasets: [
        {
          label: "ヒューマンスキル",
          data: humanSkills.map((s) => s.score ?? 0),
          backgroundColor: alpha(PROJECT_COLOR, 0.15),
          borderColor: PROJECT_COLOR,
          borderWidth: 2,

          // 丸（ポイント）
          pointRadius: 3,
          pointHoverRadius: 4,
          pointBackgroundColor: alpha(PROJECT_COLOR, 0.6),
          pointBorderColor: "#fff",
          pointBorderWidth: 1,
        },
      ],
    };
  }, [humanSkills]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: {
        min: 0,
        max: maxScore,
        ticks: { stepSize: 1 },
        pointLabels: {
          font: {
            size: isDesktop ? 11 : 9,
          },
          padding: isDesktop ? 10 : 6,
        },
      },
    },
    plugins: {
      legend: { display: false },
    },
  };

  return (
    <Box sx={{ width: "100%", height: isDesktop ? 260 : 220 }}>
      <Radar data={chartData} options={options} />
    </Box>
  );
};

export default HumanSkillRadar;
